import { render, staticRenderFns } from "./StarBirthdayManager.vue?vue&type=template&id=61c3c52c&scoped=true&"
import script from "./StarBirthdayManager.vue?vue&type=script&lang=js&"
export * from "./StarBirthdayManager.vue?vue&type=script&lang=js&"
import style0 from "./StarBirthdayManager.vue?vue&type=style&index=0&id=61c3c52c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c3c52c",
  null
  
)

export default component.exports